export const MIDDLEWARE_NAME = 'oauth2';
